// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import React from 'react';
import * as ReactDOM from 'react-dom';
import { ThemeProvider } from '@aurora/ui/aurora-design-system/src';
import { LandingPage } from './pages/LandingPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { theme } from './theme/theme';
function App() {
    var params = new URLSearchParams(window.location.search);
    var _params_get;
    var vid = (_params_get = params.get('vid')) !== null && _params_get !== void 0 ? _params_get : '';
    var path = window.location.pathname;
    switch(path){
        case '/vehicle-dispatch':
            return /*#__PURE__*/ React.createElement(LandingPage, {
                vid: vid
            });
        default:
            return /*#__PURE__*/ React.createElement(NotFoundPage, null);
    }
}
ReactDOM.render(/*#__PURE__*/ React.createElement(ThemeProvider, {
    theme: theme
}, /*#__PURE__*/ React.createElement(App, null)), document.getElementById('app'));

//# sourceMappingURL=index.js.map